// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dialog-div[data-v-d955a242] {\n  height: 60vh;\n  overflow: auto;\n}\n.button-bar[data-v-d955a242] {\n  background-color: #fceded;\n}\n.button-bar .label[data-v-d955a242] {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
